<template>
<div class="paySuccess-content">
  <div class="con-header"><img src="https://resource.rcclchina.com.cn/paySuccess/success.png" alt="">感谢您预订岸上观光！</div>
  <div class="con-notice">
    <div class="con-notice-left">
      您可以继续选择 <span>皇家行前订</span><br>
      <span>提前规划</span>您的海上假期，<br>
      吃喝玩乐购全覆盖，<span>行前预订价更优！</span>
    </div>
    <div class="con-notice-right">
      <img src="https://resource.rcclchina.com.cn/paySuccess/routeLogo.png" alt="">
    </div>
  </div>
  <div class="con-notice route-reserve" style="margin-top: 13px">
    <div v-for="(item,index) in skipList" :key="index" :class="item.className">
      <div class="notice-item" @click="goPcpItem(item.routeUrl,item.modelName)">
        <img :src="item.imgUrl" alt="">
        <div class="item-reserve">点击预订></div>
      </div>
    </div>
  </div>
  <div class="reserve-btn" @click="goPcp">前往预订</div>
  <div class="pcp-advantage">
    <img src="https://resource.rcclchina.com.cn/paySuccess/pcp-advantage.png" alt="">
  </div>

  <common-confirm :value="showShorexSubmitKoreaAlter" width="300px" type="custom">
<!--    <div class="custom-confirm-title">{{shorexSubmitKoreaAlterTitle}}</div>-->
    <div class="custom-confirm-content">
      <div class="inner-html" v-html="shorexSubmitKoreaAlterContent"></div>
    </div>
    <div class="custom-confirm-footer">
      <div class="btn" @click="shorexSubmitKoreaAlterClose">已知悉</div>
    </div>
  </common-confirm>
</div>
</template>
<script>
import api from "@/api";
import {gioTracking} from "@/utilities/tools";
const CommonConfirm = () => import('@/components/Common/CommonConfirm.vue')

export default {
  components: {
    CommonConfirm
  },
  data(){
    return{
      skipList:[
        {imgUrl:'https://resource.rcclchina.com.cn/wechatMiniProgram/shorex/pcpNetwork_2026.png',routeUrl:'/Rccl.PCP/product/Wifi',className:'',modelName:'pcpUpsellWifi'},
        {imgUrl:'https://resource.rcclchina.com.cn/wechatMiniProgram/shorex/pcpFood_2026.png',routeUrl:'/Rccl.PCP/product/dining',className:'item-food',modelName:'pcpUpsellFood'},
        {imgUrl:'https://resource.rcclchina.com.cn/wechatMiniProgram/shorex/pcpActivity_2026.png',routeUrl:'/Rccl.PCP/product/activity',className:'',modelName:'pcpUpsellEvent'},
        {imgUrl:'https://resource.rcclchina.com.cn/wechatMiniProgram/shorex/pcpService_2026.png',routeUrl:'/Rccl.PCP/product/service',className:'item-serve',modelName:'pcpUpsellService'}
      ],
      token:'',
      showShorexSubmitKoreaAlter: false,
      shorexSubmitKoreaAlterTitle: "",
      shorexSubmitKoreaAlterContent: ""
    }
  },
  async beforeMount() {
    this.$store.commit("SET_PAGE_TITLE", "预订成功");
    this.$store.dispatch("HIDE_HEADER_BAR", {
      isHideHeader: false,
      isHideFooter: true,
    });
    await this.getToken()
    const isShowPopup = this.$route.query.isShowPopup;
    if (isShowPopup === 'true' || isShowPopup === true) {
      await this.getShorexSubmitKoreaAlter();
    }
  },
  methods:{
    async getToken() {
      const {data} = await api.user.getPcpToken()
      if (data && data.length > 0) {
        this.token = data
      }
    },
    goPcpItem(url,name){
      gioTracking('track','evt_ButtonClicked',{'btnTypes':name})
      location.href=process.env.VUE_APP_PCP_URL + url+`?token=${this.token}&hmsr=rcclchinamb&hmpl=paidupsell&hmcu=pcp&hmci=internet&hmkw=`
    },
    goPcp() {
      gioTracking('track','evt_ButtonClicked',{'btnTypes':'pcpUpsellBook'})
      location.href = process.env.VUE_APP_PCP_URL + `/Rccl.Pcp/Home/Index?token=${this.token}&hmsr=rcclchinamb&hmpl=paidupsell&hmcu=pcp&hmci=hp&hmkw=`
    },
    async getShorexSubmitKoreaAlter() {
      const {success, data} = await api.page.getContentByKey({
        key: 'SHOREX_SUBMIT_KOREA_ALTER'
      })
      if (success && data) {
        if(data) {
          this.showShorexSubmitKoreaAlter = true;
          this.shorexSubmitKoreaAlterTitle = data.title;
          this.shorexSubmitKoreaAlterContent = data.content;
        }
      }
    },
    shorexSubmitKoreaAlterClose() {
      this.showShorexSubmitKoreaAlter = false;
      this.shorexSubmitKoreaAlterTitle = "";
      this.shorexSubmitKoreaAlterContent = "";
    }
  }
}
</script>
<style lang="less" scoped>
.paySuccess-content{
  width: 100%;
  background: linear-gradient( 180deg, #0297EA 0%, #95D2F7 34%, #F6FAFF 100%);
  padding: 0 11px 27px;
  & .con-header{
    padding-top: 25px;
    font-weight: 600;
    font-size: 14px;
    color: #FFFFFF;
    margin-bottom: 17px;
    display: flex;
    align-items: center;
    padding-left: 11px;
    gap: 8px;
    & img{
      width: 20px;
      height: 20px;
    }
  }
  & .con-notice{
    width: 100%;
    display: flex;
    background-color: #fff;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    padding: 11px 10px 10px 14px;
    & .con-notice-left{
      width: 100%;
      height: 66px;
      & span{
        color: #1B82CB;
        font-weight: 600;
      }
    }
    & .con-notice-right{
      width: 88px;
      padding: 18px 0;
      & img{
        width: 100%;
        height: 24px;
      }
    }
  }
  .route-reserve{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 7px !important;
    right: 0;
    position: relative;
    row-gap: 8px;
    & .item-food{
      position: absolute;
      top: 7px;
      right: 7px;
    }
    & .item-serve{
      position: absolute;
      bottom: 7px;
      right: 7px;
    }
    & .notice-item{
      width: 177px;
      height: 154px;
      border-radius: 5px;
      position: relative;

      & img{
        width: 100%;
        height: 100%;
      }
      & .item-reserve{
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        position: absolute;
        bottom: 5px;
        right: 7px;
      }
    }
  }
  & .reserve-btn{
    width: 100%;
    height: 46px;
    background: linear-gradient( 225deg, #FFDB17 0%, #FCBF00 100%);
    border-radius: 22px;
    margin: 25px 0 21px;
    font-weight: 500;
    font-size: 16px;
    color: #404040;
    text-align: center;
    line-height: 46px;
  }
  & .pcp-advantage{
    width: 100% ;
    height: 135px;
    border-radius: 5px;
    overflow: hidden;
    & img{
      width: 100%;
      height: 100%;
    }
  }
}
.custom-confirm-title {
  padding: 15px 0 9px;
  margin: 0 17px;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  border-bottom: 1px solid #eee;
  color: #000000;
}
.custom-confirm-content {
  font-size: 14px;
  padding: 15px 20px;
  & .inner-html {
    & p {
      font-size: 12px;
      color: #5e5e5e;
      margin-bottom: 0;
      margin-top: 4px;
    }
  }
}
.custom-confirm-footer {
  height: 44px;
}
.custom-confirm-footer .btn {
  line-height: 44px;
  height: 44px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #333;
  background:linear-gradient(225deg,rgba(255,219,23,1) 0%,rgba(252,191,0,1) 100%);
  border-radius: 0 0 5px 5px;
}
</style>
<style lang="less">
.custom-confirm-content {
  max-height: 58vh;
  overflow-x: hidden;
  overflow-y: auto;
  & .inner-html {
    & p {
      font-size: 13px;
      color: #333;
      margin-bottom: 0;
      margin-top: 4px;
      &:first-child {
        margin-top: 0;
      }
    }
    & img {
      max-width: 100% !important;
    }
  }
}
</style>